import request from '@/utils/request'
import { API_CAIYUN_KEY, LOCATION } from '@/utils/config'

const URL = `/${API_CAIYUN_KEY}/${LOCATION}`

//通用天气
export function getWeather(params){
    return request({
        url:`${URL}/weather.json`,
        method:'get',
        params
    })
}

//实时天气
export function getWeatherNow() {
    return request({
        url: `${URL}/realtime.json`,
        method: 'get'
    })
}

//逐小时预报(未来24小时)
export function getWeatherHours(hours) {
    return request({
        url: `${URL}/hourly.json?hourlysteps=${hours}`,
        method: 'get'
    })
}

/**
 * 逐天天气预报
 * @param {*} days 未来days天天气预报
 * @returns 
 * e.g https://api.qweather.com/v7/weather/3d?
 */
export function getWeatherDays(days) {
    return request({
        url: `${URL}/daily.json?dailysteps=${days}`,
        method: 'get'
    })
}
